"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseXML = exports.parseStat = exports.getPatcher = exports.createClient = void 0;
var factory_1 = require("./factory");
Object.defineProperty(exports, "createClient", { enumerable: true, get: function () { return factory_1.createClient; } });
var patcher_1 = require("./compat/patcher");
Object.defineProperty(exports, "getPatcher", { enumerable: true, get: function () { return patcher_1.getPatcher; } });
__exportStar(require("./types"), exports);
var dav_1 = require("./tools/dav");
Object.defineProperty(exports, "parseStat", { enumerable: true, get: function () { return dav_1.parseStat; } });
Object.defineProperty(exports, "parseXML", { enumerable: true, get: function () { return dav_1.parseXML; } });
